export default "__VITE_ASSET__7ZmrueJ5__";